import React from 'react';

import classNames from "classnames";
import styles from "./textual-odds.module.scss";
import {observer} from 'mobx-react';
import {StringToJsx} from "../string-to-jsx";
import {Image} from "../image/image";
import {BookmakerLogoParams} from "../../../domain/common/bookmaker/models/bookmaker-logo-params";
import {GAME_CARD} from "../game-card/game-card.consts";
import {useBetsImpression} from "../../../infrastructure/hooks/useBetsImpression";
import {Link} from "../link/link";
import {LINK_REL} from "../../consts";

export const TextualOddsCta = observer(({bettingOpportunity, controller, bookieClickEvent, bookieHrefModel, subSource}) => {
  const {state} = controller;
  const {appState} = state;
  const canClickBookie = !!(bookieHrefModel && bookieClickEvent);

  const betsImpressionParams = {
    bookieId: bettingOpportunity.bookmaker.id,
    bookieName: bettingOpportunity.bookmaker.name,
    sportTypeId: appState.context.sportType?.id,
    marketType: bettingOpportunity.lineTypeId,
    subSource
  }

  const ref = useBetsImpression(controller, betsImpressionParams);

  const containerProps = {
    ref,
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    className: classNames(styles.textual_odds_cta),
    onClick: canClickBookie ? (e) => {
      e.stopPropagation();
      e.preventDefault();

      bookieClickEvent?.(bettingOpportunity.odds)
    } : undefined
  }

  const textContainerProps = {
    className: classNames(styles.textual_odds_cta_text_container, {[styles.not_clickable]: !canClickBookie}),
    style: {borderColor: bettingOpportunity.bookmaker.color}
  }

  const logoProps = {
    className: classNames(styles.textual_odds_logo, {[styles.not_clickable]: !canClickBookie}),
    src: new BookmakerLogoParams({
      width: GAME_CARD.ICONS_SIZES.BOOKIE_LOGO.width,
      height: GAME_CARD.ICONS_SIZES.BOOKIE_LOGO.height
    }, bettingOpportunity.bookmaker),
    style: {borderColor: bettingOpportunity.bookmaker.color}
  }

  return (
    <Link {...containerProps}>
      {
        bettingOpportunity?.bookmaker ? <Image {...logoProps}/> : null
      }
      <div {...textContainerProps}>
        <StringToJsx domString={bettingOpportunity?.ctaTextSpan}/>
      </div>
    </Link>
  )
});
